import { useState, useEffect } from 'react';
import Logo from './Logo';
import { startCheckout } from '../utils/checkout';
import { trackEvent } from '../utils/analytics';
import { DOWNLOAD_URL } from '../utils/constants';

const NAV_LINKS = [
  { href: '#features', label: 'Features' },
  { href: '#live', label: 'In the meeting' },
  { href: '#after', label: 'After' },
  { href: '#pricing', label: 'Pricing' },
];

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  // Someone who just paid shouldn't be advertised "Buy" next to their own
  // receipt banner — swap the nav CTA to Download for the rest of the session.
  // The URL param is read at render time (PurchaseSuccess strips it in an
  // effect, i.e. after this render); the sessionStorage guard PurchaseSuccess
  // writes covers later in-session navigations.
  const [purchased] = useState(
    () =>
      new URLSearchParams(window.location.search).get('purchase') === 'success' ||
      sessionStorage.getItem('solidly.tracked.purchase-success') === '1'
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`nav ${scrolled || menuOpen ? 'nav--scrolled' : ''}`}>
      <div className="nav-inner">
        <a href="#top" className="nav-brand" aria-label="Solidly Meet home" onClick={closeMenu}>
          <span className="nav-logo" aria-hidden="true">
            <Logo size={26} />
          </span>
          <span className="nav-brand-text">
            Solidly <span className="nav-brand-accent">Meet</span>
          </span>
        </a>

        <nav className="nav-links" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        {purchased ? (
          <a
            className="btn btn-primary btn-sm"
            href={DOWNLOAD_URL}
            onClick={() =>
              trackEvent('installer_download', { event_category: 'engagement', source: 'nav' })
            }
          >
            Download
          </a>
        ) : (
          <button className="btn btn-primary btn-sm" onClick={() => startCheckout('nav')}>
            Buy — $25
          </button>
        )}

        <button
          type="button"
          className="nav-menu-toggle"
          aria-expanded={menuOpen}
          aria-controls="nav-mobile-menu"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span aria-hidden="true">{menuOpen ? '✕' : '☰'}</span>
        </button>
      </div>

      {menuOpen && (
        <nav id="nav-mobile-menu" className="nav-mobile-panel" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={closeMenu}>
              {link.label}
            </a>
          ))}
          {purchased ? (
            <a
              className="btn btn-primary"
              href={DOWNLOAD_URL}
              onClick={() => {
                closeMenu();
                trackEvent('installer_download', {
                  event_category: 'engagement',
                  source: 'nav_mobile',
                });
              }}
            >
              Download for Windows
            </a>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                closeMenu();
                startCheckout('nav_mobile');
              }}
            >
              Buy now — $25 →
            </button>
          )}
        </nav>
      )}
    </header>
  );
};

export default Navigation;
